export default {
    'A name is required': 'Ein Name ist erforderlich',
    Age: 'Alter',
    'Total money spent, $': 'Insgesamt ausgegebenes Geld, $',
    Clients: 'Kunden',
    Income: 'Einkommen',
    'First name': 'Vorname',
    'Last name': 'Familienname',
    Position: 'Besetzung',
    'Click para seleccionar ': 'Klicken Sie um auszuwählen',
    Notifications: 'Benachrichtigungen',
    Yes: 'Ja',
    No: 'Nein',
    'City, country': 'Stadt Land',
    Address: 'Adresse',
    Birthday: 'Geburtstag',
    'Click to add tags': 'Klicken Sie, um Tags hinzuzufügen',
    Notes: 'Anmerkungen',
    Reset: 'Zurücksetzen',
    Save: 'Speichern',
    'Top clients': 'Top-Kunden',
    'Money spent, $': 'Geld ausgegeben, $',
    '-- Not selected --': '-- Nicht ausgewählt --',
    'Sales manager': 'Verkaufsleiter',
    'Customer service': 'Kundendienst',
    'General manager': 'Generaldirektor',
    'Awarded Badges': 'Ausgezeichnete Abzeichen',
    New: 'Neu',
    Customer: 'Kunde',
    Supplier: 'Lieferant',
    Discount: 'Rabatt',
    'Old Buddy': 'Alter Freund',
    'Avid Supporter': 'Begeisterter Unterstützer',
    Date: 'Datum',
    Payment: 'Zahlung',
    Purchase: 'Kauf',
    Sum: 'Summe',
    Left: 'Links',
    'Nothing on this day': 'Nichts an diesem Tag',
    Information: 'Information',
    Statistics: 'Statistiken',
    Transactions: 'Transaktionen',
    Customers: 'Kunden',
    Charts: 'Diagramme',
    'See all notifications': 'Alle Benachrichtigungen',
    'Deposits News': 'Einzahlungen Nachrichten',
    'Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...':
        'Sehr geehrte Kundin, sehr geehrter Kunde, wir informieren Sie über die folgenden Änderungen: ab dem 24. September 2018 alle Transaktio...',
    'Search Improved': 'Suche verbessert',
    'Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...':
        'Sehr geehrter Kunde! Nach den neuesten Updates der SeekMeEverywhere-Engines ist Ihre Suche zuverlässiger und be...',
    'Transaction Reports': 'Transaktionsberichte',
    'Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...':
        'Sehr geehrter Kunde, wir informieren Sie über eine Änderung des Datums der monatlichen Transaktionsberichte. Ab dem 20...',
    Warning: 'Warnung',
    'Dear client, we know where you store your passwords. We highly recommend you to memorize them and destroy those memos of yours.':
        'Sehr geehrter Kunde, wir wissen, wo Sie Ihre Passwörter speichern. Wir empfehlen Ihnen dringend, sich diese auswendig zu merken.',
    'Editing customers data': 'Kundendaten bearbeiten',
    'Dear client, if you want to see the details on every customer and edit them, double-click the customer in the list on the right.':
        'Sehr geehrter Kunde, wenn Sie die Details zu jedem Kunden sehen und bearbeiten möchten, doppelklicken Sie auf den Kunden in der Liste...',
    'We miss you': 'Wir vermissen Ihnen',
    'Dear client, it has been a while since you talked to us. We are waiting for you in the same place at the same time.':
        'Sehr geehrter Kunde, es ist eine Weile her, seit Sie mit uns gesprochen haben. Wir warten auf Sie am selben Ort zur gleichen Zeit.',
    'Have a nice day': 'Einen schönen Tag!',
    'Dear client, whenever you are reading this, we wish you a merry day. May the luck and success attend you.':
        'Lieber Kunde, wenn Sie dies lesen, wünschen wir Ihnen einen schönen Tag. Möge das Glück und der Erfolg Sie begleiten.',
    Localization: 'Lokalisierung',
    'Dear client, you can pick one of the six languages we provided for this demo app. Click the icon in the top right corner.':
        'Sie können eine der sechs Sprachen auswählen. Klicken Sie auf das Symbol in der oberen rechten Ecke.',
    'We love you': 'Wir lieben Ihnen',
    'Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.':
        'Lieber Kunde, wir lieben Ihnen sehr. Kontaktieren Sie uns und laden Sie Webix herunter. Dann werden wir Ihnen ewig lieben.',
    Persons: 'Personen',
    'Click twice to see more goodies': 'Klicken Sie zweimal, um weitere Goodies zu sehen',
    Saved: 'Gerettet',
    Settings: 'Einstellungen',
    'Regional settings': 'Regionale Einstellungen',
    Language: 'Sprache',
    'Date format': 'Datumsformat',
    'Money format': 'Geldformat',
    'Environment settings': 'Umgebungseinstellungen',
    Theme: 'Thema',
    Light: 'Helles',
    Dark: 'Dunkles',
    'Max list length': 'Maximale Listenlänge',
    'Default settings': 'Standardeinstellungen',
    'Open latest notifications': 'Öffnen Sie die letzten Benachrichtigungen',
    'Go to settings': 'Gehe zu den Einstellungen',
    All: 'Alle',
    Payments: 'Zahlungen',
    Incoming: 'Eingehend',
    Email: 'Email',
    Widgets: 'Widgets',
    Demos: 'Demos',
    Prices: 'Preise',
    Tutorials: 'Anleitungen',
    'Tirane, Albania': 'Tirana, Albanien',
    'Buenos Aires, Argentina': 'Buenos Aires, Argentinien',
    'Canberra, Australia': 'Canberra, Australien',
    'Vienna, Austria': 'Wien, Österreich',
    'Minsk, Belarus': 'Minsk, Belarus',
    'Brussels, Belgium': 'Brüssel, Belgien',
    'Brasilia, Brazil': 'Brasilien, Brasilien',
    'Ottawa, Canada': 'Ottawa, Kanada',
    'Beijing, China': 'Peking, China',
    'Prague, Czech Republic': 'Prag, Tschechische Republik',
    'Copenhagen, Denmark': 'Kopenhagen, Dänemark',
    'Cairo, Egypt': 'Kairo, Ägypten',
    'Helsinki, Finland': 'Helsinki, Finnland',
    'Paris, France': 'Paris, Frankreich',
    'Tbilisi, Georgia': 'Tiflis, Georgien',
    'Berlin, Germany': 'Berlin, Deutschland',
    'New Delhi, India': 'Neu Delhi, Indien',
    'Dublin, Ireland': 'Dublin, Irland',
    'Rome, Italy': 'Rom, Italien',
    'Tokyo, Japan': 'Tokyo, Japan',
    'Wellington, New Zealand': 'Wellington, Neuseeland',
    'Seoul, Republic of Korea': 'Seoul, Republik Korea',
    'Madrid, Spain': 'Madrid, Spanien',
    'Stockholm, Sweden': 'Stockholm, Schweden',
    'Washington, United States': 'Washington, Vereinigte Staaten',
    'Payment History': 'Zahlungshistorie',
    'Origin of clients': 'Herkunft der Kunden',
    'Income from various age groups': 'Einkommen aus verschiedenen Altersgruppen',
    'Clients by occupation': 'Kunden nach Beruf',
    'No new notifications': 'Keine Nachrichten',
};

// FILE DOCUMENTED
